<!--
 * @Descripttion: 整理逻辑,添加备注!!!
 * @version: 
 * @Author: Duanshuai
 * @Date: 2022-01-24 08:54:29
 * @LastEditors: ------
 * @LastEditTime: 2022-02-18 08:55:18
-->
<template>
  <div class="fangTan_container">
    <van-nav-bar
      title="客户档案详情"
      @click-left="$router.push('/myAccountlist')"
      left-arrow
      safe-area-inset-top
      placeholder
    />
    <van-form @submit="onSubmit">
      <div class="con">
        <div class="myInfo">
          <div class="info">
            <div class="title">
              <span>意向单信息详情</span>
              <div class="box">
                <div class="box_item">
                  <div class="box_item_title">小程序账号信息</div>
                  <div class="contain">
                    姓名:{{ info.name || '-' }}
                  </div>
                  <div class="contain contains">
                    手机号:{{ info.mobile || "-" }}
                  </div>
                  <div class="contain contains">
                    爱心豆余额:{{ info.activeScore || "0.00" }}
                  </div>
                  <div class="contain contains">
                    绑定微信:{{ info.nickname || "-" }}
                  </div>
                  <div class="contain contains">
                    推荐人:{{ info.referred || "-" }}
                  </div>
                  <div class="contain contains">
                    已消费金额:{{ info.sumAmount || "0.00" }}
                  </div>
                  <div class="contain contains">
                    客户来源:{{ info.consumerSource_dictText || "-" }}
                  </div>
                </div>
              </div>

              <div class="box">
                <div class="box_item">
                  <div class="box_item_title">基本信息</div>
                  <div class="contain">
                    注册时间:{{ info.registerTime || '-' }}
                  </div>
                  <div class="contain contains">
                    性别:<van-dropdown-menu>
                          <van-dropdown-item 
                            v-model="formData.sex" 
                            :options="choice1"
                            placeholder="请选择性别"
                          />
                        </van-dropdown-menu>
                  </div>
                  <div class="contain contains">
                    年龄:<van-field 
                          v-model="formData.age" 
                          placeholder="请输入年龄"
                        />
                  </div>
                  <div class="contain contains">
                    固定电话:<van-field 
                          v-model="formData.telephone" 
                          placeholder="请输入固定电话"
                        />
                  </div>
                  <div class="contain contains">
                    微信:<van-field 
                          v-model="formData.wechat" 
                          placeholder="请输入微信"
                        />
                  </div>
                  <div class="contain contains">
                    身份证号:<van-field 
                          v-model="formData.idCard" 
                          placeholder="请输入身份证号"
                        />
                  </div>
                  <div class="contain contains">
                    生日:<van-field 
                            v-model="formData.birthDate" 
                            readonly
                            placeholder="请选择生日"
                            @click="showBirthPicker = true"
                          />
                          <van-popup v-model="showBirthPicker" position="bottom" round>
                          <van-datetime-picker
                            v-model="currentBirthDate"
                            type="date"
                            title="选择生日"
                            :min-date="minDate"
                            :max-date="maxDate"
                            @confirm="onBirthConfirm"
                            @cancel="showBirthPicker = false"
                          />
                        </van-popup>
                  </div>
                  <div class="contain contains">
                    身高:<van-field 
                          v-model="formData.stature" 
                          placeholder="请输入身高"
                        />cm
                  </div>
                  <div class="contain contains">
                    体重:<van-field 
                          v-model="formData.weight" 
                          placeholder="请输入体重"
                        />kg
                  </div>
                  <div class="contain contains">
                    户籍地:<van-field
                            v-model="formData.censusRegisterGround"
                            readonly
                            placeholder="请选择户籍地"
                            @click="showAreaPicker = true"
                          />
                          <van-popup v-model="showAreaPicker" position="bottom" round>
                            <van-area
                              v-model="areaValue"
                              :area-list="areaList"
                              :columns-num="2"
                              title="选择户籍地（省-市）"
                              @confirm="onAreaConfirm"
                              @cancel="showAreaPicker = false"
                            />
                          </van-popup>
                  </div>
                  <div class="contain contains">
                    学历:<van-dropdown-menu>
                          <van-dropdown-item 
                            v-model="formData.academicBg" 
                            :options="choiceOn"
                            placeholder="请选择学历"
                          />
                        </van-dropdown-menu>
                  </div>
                  <div class="contain contains">
                    民族:<van-field 
                          v-model="formData.nation" 
                          placeholder="请选择民族"
                        />
                        <!-- <van-dropdown-menu>
                          <van-dropdown-item 
                            v-model="formData.nation" 
                            :options="options"
                            placeholder="请选择民族"
                          />
                        </van-dropdown-menu> -->
                  </div>
                  <div class="contain contains">
                    婚否:<van-dropdown-menu>
                          <van-dropdown-item 
                            v-model="formData.maritalStatus" 
                            :options="choice3"
                            placeholder="请选择婚否"
                          />
                        </van-dropdown-menu>
                  </div>
                  <div class="contain contains">
                    政治面貌:<van-dropdown-menu>
                            <van-dropdown-item 
                              v-model="formData.politicsStatus" 
                              :options="choice4"
                              placeholder="请选择政治面貌"
                            />
                          </van-dropdown-menu>
                  </div>
                  <div class="contain contains">
                    原职业:<van-field 
                          v-model="formData.previousOccupation" 
                          placeholder="请输入原职业"
                        />
                  </div>
                  <div class="contain contains">
                    宗教:<van-field 
                          v-model="formData.religion" 
                          placeholder="请输入宗教"
                        />
                  </div>
                  <div class="contain contains">
                    住址:<van-field
                            v-model="formData.homeAddress"
                            readonly
                            placeholder="请选择户籍地"
                            @click="showHomePicker = true"
                          />
                          <van-popup v-model="showHomePicker" position="bottom" round>
                            <van-area
                              v-model="homeValue"
                              :area-list="homeList"
                              :columns-num="3"
                              title="选择户籍地（省-市-区）"
                              @confirm="onHomeConfirm"
                              @cancel="showHomePicker = false"
                            />
                          </van-popup>
                  </div>
                  <div class="contain contains">
                    现居住地址:<van-field 
                          v-model="formData.detailAddress" 
                          placeholder="请输入现居住地址"
                        />
                  </div>
                  <div class="contain contains">
                    护理产品类型:<van-dropdown-menu>
                                  <van-dropdown-item 
                                    v-model="formData.nurseTypes" 
                                    :options="choice5"
                                    placeholder="请选择护理产品类型"
                                  />
                                </van-dropdown-menu>
                        <!-- <van-field 
                          v-model="formData.nurseTypes" 
                          placeholder="请输入护理产品类型"
                        /> -->
                  </div>
                  <div class="contain contains">
                    开发人:<van-field 
                          v-model="formData.salesman" 
                          placeholder="请输入开发人"
                        />
                  </div>
                  <div class="contain contains">
                    所属门店:<van-dropdown-menu>
                            <van-dropdown-item 
                              v-model="formData.storeId" 
                              :options="choice14"
                              @change="closedChange"
                              placeholder="请选择所属门店"
                            />
                          </van-dropdown-menu>
                  </div>
                  <div class="contain contains">
                    护理员:<van-dropdown-menu>
                            <van-dropdown-item 
                              v-model="formData.nurseAssistantId" 
                              :options="choice15"
                              placeholder="请选择护理员"
                            />
                          </van-dropdown-menu>
                  </div>
                  <div class="contain contains">
                    督导员:<van-dropdown-menu>
                            <van-dropdown-item 
                              v-model="formData.supervisorId" 
                              :options="choice16"
                              placeholder="请选择督导员"
                            />
                          </van-dropdown-menu>
                  </div>
                  <div class="contain contains">
                    服务等级:<van-radio-group v-model="formData.serviceGrade">
                                <van-radio v-for="item in choice19" :key="item.value" :name="item.value">{{ item.text }}</van-radio>
                              </van-radio-group>
                  </div>
                  <div class="contain contains">
                    客户分类:<van-radio-group v-model="formData.classify">
                                <van-radio v-for="item in choice20" :key="item.value" :name="item.value">{{ item.text }}</van-radio>
                              </van-radio-group>
                  </div>
                  <div class="contain contains">
                    画像分类:<van-radio-group v-model="formData.portraitClassify">
                              <van-radio v-for="item in choice21" :key="item.value" :name="item.value">{{ item.text }}</van-radio>
                            </van-radio-group>
                  </div>
                </div>
              </div>

              <div class="box">
                <div class="box_item">
                  <div class="box_item_title">画像信息</div>
                  <div class="contain contains">
                    家庭结构:<van-radio-group v-model="formData.familyStructure">
                              <van-radio v-for="item in choice22" :key="item.value" :name="item.value">{{ item.text }}</van-radio>
                            </van-radio-group>
                  </div>
                  <div class="contain contains">
                    是否失独:<van-radio-group v-model="formData.losingSingleChild">
                              <van-radio v-for="item in choice23" :key="item.value" :name="item.value">{{ item.text }}</van-radio>
                            </van-radio-group>
                  </div>
                  <div class="contain contains">
                    身体状态:<van-radio-group v-model="formData.physicalCondition">
                              <van-radio v-for="item in choice24" :key="item.value" :name="item.value">{{ item.text }}</van-radio>
                            </van-radio-group>
                  </div>
                  
                  <div class="contain contains">
                    居家环境:<van-radio-group v-model="formData.homeEnvironment">
                              <van-radio v-for="item in choice25" :key="item.value" :name="item.value">{{ item.text }}</van-radio>
                            </van-radio-group>
                  </div>
                  
                  <div class="contain contains">
                    社交关系:<van-radio-group v-model="formData.socialRelation">
                              <van-radio v-for="item in choice26" :key="item.value" :name="item.value">{{ item.text }}</van-radio>
                            </van-radio-group>
                  </div>
                  
                  <div class="contain contains">
                    外观状态:<van-radio-group v-model="formData.apparentCondition">
                              <van-radio v-for="item in choice27" :key="item.value" :name="item.value">{{ item.text }}</van-radio>
                            </van-radio-group>
                  </div>
                  
                  <div class="contain contains">
                    沟通能力:<van-radio-group v-model="formData.communicateAbility">
                              <van-radio v-for="item in choice28" :key="item.value" :name="item.value">{{ item.text }}</van-radio>
                            </van-radio-group>
                  </div>
                  
                  <div class="contain contains">
                    判断能力:<van-radio-group v-model="formData.judgementAbility">
                              <van-radio v-for="item in choice29" :key="item.value" :name="item.value">{{ item.text }}</van-radio>
                            </van-radio-group>
                  </div>
                  
                  <div class="contain contains">
                    行走能力:<van-radio-group v-model="formData.walkAbility">
                              <van-radio v-for="item in choice30" :key="item.value" :name="item.value">{{ item.text }}</van-radio>
                            </van-radio-group>
                  </div>
                  
                  <div class="contain contains">
                    自理能力:<van-radio-group v-model="formData.takeCareOneselfAbility">
                              <van-radio v-for="item in choice31" :key="item.value" :name="item.value">{{ item.text }}</van-radio>
                            </van-radio-group>
                  </div>
                  
                  <div class="contain contains">
                    性格特征:<van-checkbox-group v-model="formData.traitsCharacter">
                              <van-checkbox v-for="item in choice32" :key="item.value" :name="item.value">{{ item.text }}</van-checkbox>
                            </van-checkbox-group>
                  </div>
                  
                  <div class="contain contains">
                    饮食状况:<van-radio-group v-model="formData.dietetic">
                              <van-radio v-for="item in choice33" :key="item.value" :name="item.value">{{ item.text }}</van-radio>
                            </van-radio-group>
                  </div>
                  
                  <div class="contain contains">
                    饮食习惯:<van-checkbox-group v-model="formData.dieteticHabit">
                              <van-checkbox v-for="item in choice34" :key="item.value" :name="item.value">{{ item.text }}</van-checkbox>
                            </van-checkbox-group>
                  </div>
                  
                  <div class="contain contains">
                    消费特征:<van-checkbox-group v-model="formData.consumptionFeature">
                              <van-checkbox v-for="item in choice35" :key="item.value" :name="item.value">{{ item.text }}</van-checkbox>
                            </van-checkbox-group>
                  </div>
                  
                  <div class="contain contains">
                    购买能力:<van-radio-group v-model="formData.purchasingPower">
                              <van-radio v-for="item in choice36" :key="item.value" :name="item.value">{{ item.text }}</van-radio>
                            </van-radio-group>
                  </div>
                  
                  <div class="contain contains">
                    兴趣:<van-checkbox-group v-model="formData.interests">
                              <van-checkbox v-for="item in choice37" :key="item.value" :name="item.value">{{ item.text }}</van-checkbox>
                            </van-checkbox-group>
                  </div>
                  
                  <div class="contain contains">
                    风险评估:<van-radio-group v-model="formData.riskAssessment">
                              <van-radio v-for="item in choice38" :key="item.value" :name="item.value">{{ item.text }}</van-radio>
                            </van-radio-group>
                  </div>
                  
                  <!-- <div class="contain contains">
                    既往病史:<van-checkbox-group v-model="formData.anamnesis">
                              <van-checkbox v-for="item in choice39" :key="item.value" :name="item.value">{{ item.text }}</van-checkbox>
                            </van-checkbox-group>
                  </div> -->
                </div>
              </div>

              <div class="box">
                <div class="box_item">
                  <div class="box_item_title">护理需求</div>
                  <div class="contain contains">
                    特殊项目:<van-dropdown-menu>
                              <van-dropdown-item 
                                v-model="formData.specialNurseType" 
                                :options="choice6"
                                placeholder="请选择特殊项目"
                              />
                            </van-dropdown-menu>
                  </div>
                  <div class="contain contains">
                    常规技能:<van-dropdown-menu>
                              <van-dropdown-item 
                                v-model="formData.conventionSkill" 
                                :options="choice7"
                                placeholder="请选择常规技能"
                              />
                            </van-dropdown-menu>
                  </div>
                  <div class="contain contains">
                    特殊技能:<van-dropdown-menu>
                              <van-dropdown-item 
                                v-model="formData.specialSkill" 
                                :options="choice8"
                                placeholder="请选择常规技能"
                              />
                            </van-dropdown-menu>
                  </div>
                  <div class="contain contains">
                    人员需求/性别:<van-dropdown-menu>
                                    <van-dropdown-item 
                                      v-model="formData.requireSex" 
                                      :options="choice9"
                                      placeholder="请选择性别"
                                    />
                                  </van-dropdown-menu>
                  </div>
                  <div class="contain contains">
                    人员需求/年龄段:<van-dropdown-menu>
                                    <van-dropdown-item 
                                      v-model="formData.requireAge" 
                                      :options="choice10"
                                      placeholder="请选择年龄段"
                                    />
                                  </van-dropdown-menu>
                  </div>
                  <div class="contain contains">
                    人员需求/体型:<van-dropdown-menu>
                                    <van-dropdown-item 
                                      v-model="formData.requireBodily" 
                                      :options="choice11"
                                      placeholder="请选择体型"
                                    />
                                  </van-dropdown-menu>
                  </div>
                  <div class="contain contains">
                    学历:<van-dropdown-menu>
                          <van-dropdown-item 
                            v-model="formData.requireAcademicBg" 
                            :options="choice12"
                            placeholder="请选择学历"
                          />
                        </van-dropdown-menu>
                  </div>
                  <div class="contain contains">
                    消费需求:<van-dropdown-menu>
                              <van-dropdown-item 
                                v-model="formData.requireConsumption" 
                                :options="choice13"
                                placeholder="请选择消费需求"
                              />
                            </van-dropdown-menu>
                  </div>
                  <div class="contain contains">
                    其他特殊要求:<van-field 
                                    v-model="formData.requirePeculiarity" 
                                    placeholder="请输入其他特殊要求"
                                  />
                                <!-- <van-dropdown-menu>
                                  <van-dropdown-item 
                                    v-model="formData.requirePeculiarity" 
                                    :options="options"
                                    placeholder="请选择其他特殊要求"
                                  />
                                </van-dropdown-menu> -->
                  </div>
                </div>
              </div>

              

              <div class="box">
                <div class="box_item"> 
                  <div class="box_item_title">信息操作</div>
                  
                  <!-- 家庭成员信息标签页 -->
                  <van-tabs v-model="activeTab" sticky>
                    <van-tab title="家庭成员信息">
                      <div class="family-member-table">
                        <div v-for="(member, index) in consumerFamilyMemberTable.dataSource" :key="index" class="member-item">
                          <van-cell-group :border="false">
                            <van-field
                              v-model="member.name"
                              label="姓名"
                              placeholder="请输入姓名"
                              maxlength="18"
                            />
                            <van-field
                              v-model="member.mobile"
                              label="手机号"
                              placeholder="请输入手机号"
                              maxlength="11"
                              type="tel"
                            />
                            <van-field
                              v-model="member.kinship"
                              label="关系"
                              placeholder="请选择关系"
                              readonly
                              @click="openKinshipPicker(index)"
                            />
                            <van-field
                              v-model="member.brthday"
                              label="生日"
                              placeholder="请选择生日"
                              readonly
                              @click="showMemberBirthPicker = true; currentMemberIndex = index"
                            />
                            <div class="member-actions">
                              <van-button
                                size="small"
                                type="primary"
                                @click="addFamilyMember"
                                icon="plus"
                              >添加</van-button>
                              <van-button
                                v-if="index > 0"
                                size="small"
                                type="danger"
                                @click="removeFamilyMember(index)"
                                icon="minus"
                              >删除</van-button>
                            </div>
                          </van-cell-group>
                        </div>
                      </div>
                    </van-tab>
                    
                    <van-tab title="消费记录">
                      <div class="empty-state" v-if="accountOrderTable.dataSource.length === 0">
                        <van-empty description="暂无消费记录" />
                      </div>
                      <div v-else class="order-list">
                        <div v-for="(order, index) in accountOrderTable.dataSource" :key="index" class="order-item">
                          <van-cell :title="`订单号: ${order.orderNo}`" :value="`金额: ¥${order.amount}`" />
                          <van-cell title="下单时间" :value="order.createTime" />
                        </div>
                      </div>
                    </van-tab>
                    
                    <van-tab title="优惠券">
                      <div class="empty-state" v-if="accountCouponTable.dataSource.length === 0">
                        <van-empty description="暂无优惠券" />
                      </div>
                      <div v-else class="coupon-list">
                        <div v-for="(coupon, index) in accountCouponTable.dataSource" :key="index" class="coupon-item">
                          <van-cell :title="`${coupon.name}`" :value="`状态: ${coupon.status_dictText}`" />
                          <van-cell title="有效期" :value="`${coupon.startTime} 至 ${coupon.endTime}`" />
                        </div>
                      </div>
                    </van-tab>
                    
                    <van-tab title="爱心豆">
                      <div class="empty-state" v-if="accountIntegralTable.dataSource.length === 0">
                        <van-empty description="暂无爱心豆获取记录" />
                      </div>
                      <div v-else class="integral-list">
                        <div v-for="(integral, index) in accountIntegralTable.dataSource" :key="index" class="integral-item">
                          <van-cell :title="`${integral.type_dictText}`" :value="`数量: ${integral.num}`" />
                          <van-cell title="获取时间" :value="integral.createTime" />
                        </div>
                      </div>
                    </van-tab>
                  </van-tabs>
                  
                  <!-- 关系选择器 -->
                  <van-popup v-model="showKinshipPicker" position="bottom" round>
                    <van-picker
                      :columns="kinshipOptions"
                      :show-toolbar="true"
                      title="请选择关系"
                      value-key="text"
                      @confirm="onKinshipConfirm"
                      @cancel="showKinshipPicker = false"
                    />
                  </van-popup>
                  
                  <!-- 家庭成员生日选择器 -->
                  <van-popup v-model="showMemberBirthPicker" position="bottom" round>
                    <van-datetime-picker
                      v-model="currentMemberBirthDate"
                      type="date"
                      :min-date="minDate"
                      :max-date="maxDate"
                      @confirm="onMemberBirthConfirm"
                      @cancel="showMemberBirthPicker = false"
                    />
                  </van-popup>
                </div>
              </div>

              <div class="box">
                <div class="box_item">
                  <div class="box_item_title">客户访护记录</div>
                  
                  <!-- 客户访护记录标签页 -->
                  <van-tabs v-model="traceActiveTab" sticky>
                    <van-tab title="客户访护记录">
                      <div class="trace-table">
                        <div v-if="consumerTraceTable.dataSource.length === 0" class="empty-state">
                          <van-empty description="暂无客户访护信息" />
                        </div>
                        <div v-else>
                          <div v-for="(trace, index) in consumerTraceTable.dataSource" :key="index" class="trace-item">
                            <van-cell-group :border="false">
                              <van-cell title="访护时间" :value="trace.traceTime" />
                              <van-cell title="访护人员" :value="trace.traceUser" />
                              <van-cell title="访护内容" :value="trace.traceContent" />
                              <van-cell title="访护标签">
                                <template #value>
                                  <div class="tag-container">
                                    <van-tag 
                                      v-for="(tag, tagIndex) in trace.traceTags ? trace.traceTags.split(',') : []" 
                                      :key="tagIndex" 
                                      type="primary" 
                                      size="small"
                                      style="margin-right: 5px; margin-bottom: 5px;"
                                    >
                                      {{ tag }}
                                    </van-tag>
                                  </div>
                                </template>
                              </van-cell>
                              <van-cell title="下次回访时间" :value="trace.nextTraceTime" />
                            </van-cell-group>
                          </div>
                        </div>
                      </div>
                    </van-tab>
                  </van-tabs>
                </div>
              </div>

              <div style="margin: 16px" class="btn">
                <van-button
                  round
                  block
                  color="linear-gradient(-90deg, #84f5de, #4cc5f8)"
                  native-type="submit"
                  >提交</van-button
                >
              </div>
              <div style="height: 100px;"></div>
            </div>
          </div>
        </div>
      </div>
    </van-form>
  </div>
</template>

<script>
import { consumerEdit,
          getDictItems,
          loadData,
          nurseEmployeeStore,
          storeUsers, } 
from "@/api/index";
import { areaList } from '@vant/area-data';
export default {
    name: "myAccountlistEdit",
    components: {
      // van组件会自动注册，无需手动注册
    },
    data() {
      return {
        info : {},
        formData: {

        },
        showBirthPicker: false,
        currentBirthDate: new Date(),
        minDate: new Date(1900, 0, 1),
        maxDate: new Date(),
        choice1: [], // 性别 - 从字典接口获取
        choiceOn: [], // 学历 - 从字典接口获取
        
        // 标签页相关数据
        activeTab: 0,
        showKinshipPicker: false,
        showMemberBirthPicker: false,
        currentMemberIndex: 0,
        currentMemberBirthDate: new Date(),
        
        // 家庭成员信息表
        consumerFamilyMemberTable: {
          dataSource: [
            {
              id: 1,
              name: '',
              mobile: '',
              kinship: '',
              brthday: ''
            }
          ]
        },
        
        // 消费记录表
        accountOrderTable: {
          dataSource: []
        },
        
        // 优惠券表
        accountCouponTable: {
          dataSource: []
        },
        
        // 爱心豆表
        accountIntegralTable: {
          dataSource: []
        },
        
        // 客户访护记录表
        consumerTraceTable: {
          loading: false,
          dataSource: [],
          columns: [
            { title: '访护时间', dataIndex: 'traceTime' },
            { title: '访护人员', dataIndex: 'traceUser' },
            { title: '访护内容', dataIndex: 'traceContent' },
            { title: '访护标签', dataIndex: 'traceTags' },
            { title: '下次回访时间', dataIndex: 'nextTraceTime' }
          ]
        },
        
        // 访护记录标签页激活状态
        traceActiveTab: 0,
        
        // 家人关系选项
        kinshipOptions: [
          { text: '父亲', value: 'father' },
          { text: '母亲', value: 'mother' },
          { text: '配偶', value: 'spouse' },
          { text: '子女', value: 'child' },
          { text: '兄弟姐妹', value: 'sibling' },
          { text: '其他', value: 'other' }
        ],
        choice3: [], // 婚否 - 从字典接口获取
        choice4: [], // 政治面貌 - 从字典接口获取
        choice5: [], // 护理产品类型 - 从字典接口获取
        choice6: [], // 特殊项目 - 从字典接口获取
        choice7: [], // 常规技能 - 从字典接口获取
        choice8: [], // 特殊技能 - 从字典接口获取
        choice9: [], // 人员需求性别 - 从字典接口获取
        choice10: [], // 年龄段 - 从字典接口获取
        choice11: [], // 体型 - 从字典接口获取
        choice12: [], // 学历 - 从字典接口获取
        choice13: [], // 消费需求 - 从字典接口获取
        choice14: [], // 所属门店 - 从字典接口获取
        choice15: [], // 护理员 - 从字典接口获取
        choice16: [], // 督导员 - 从字典接口获取
        
        // 新增的choice数组用于其他字段
        choice17: [], // 民族
        choice18: [], // 住址
        choice19: [], // 服务等级
        choice20: [], // 客户分类
        choice21: [], // 画像分类
        choice22: [], // 家庭结构
        choice23: [], // 是否失独
        choice24: [], // 身体状态
        choice25: [], // 居家环境
        choice26: [], // 社交关系
        choice27: [], // 外观状态
        choice28: [], // 沟通能力
        choice29: [], // 判断能力
        choice30: [], // 行走能力
        choice31: [], // 自理能力
        choice32: [], // 性格特征
        choice33: [], // 饮食状况
        choice34: [], // 饮食习惯
        choice35: [], // 消费特征
        choice36: [], // 购买能力
        choice37: [], // 兴趣
        choice38: [], // 风险评估
        choice39: [], // 既往病史
        // 字典接口配置
        /* eslint-disable no-dupe-keys */
        dictConfig: {
          // 基本信息类
          'sex': 'choice1',           // 性别
          'nurse_assistant_academic_background': 'choiceOn',   // 学历
          'marital_status': 'choice3', // 婚否
          'politics_status': 'choice4', // 政治面貌
          'nation': 'choice17',       // 民族
          'home_address': 'choice18', // 住址
          
          // 护理产品类
          'nurse_type': 'choice5',   // 护理产品类型
          // 'store_id': 'choice14',     // 所属门店
          // 'nurse_assistant_id': 'choice15', // 护理员
          // 'supervisor_id': 'choice16', // 督导员
          
          // 服务等级和分类
          'service_grade': 'choice19', // 服务等级
          'classify': 'choice20',     // 客户分类
          'portrait_classify': 'choice21', // 画像分类
          
          // 画像信息类
          'family_structure': 'choice22', // 家庭结构
          'losing_single_child': 'choice23', // 是否失独
          'physical_condition': 'choice24', // 身体状态
          'home_environment': 'choice25', // 居家环境
          'social_relation': 'choice26', // 社交关系
          'apparent_condition': 'choice27', // 外观状态
          'communicate_ability': 'choice28', // 沟通能力
          'judgement_ability': 'choice29', // 判断能力
          'walk_ability': 'choice30', // 行走能力
          'take_care_oneself_ability': 'choice31', // 自理能力
          'traits_character': 'choice32', // 性格特征
          'dietetic': 'choice33',    // 饮食状况
          'dietetic_habit': 'choice34', // 饮食习惯
          'consumption_feature': 'choice35', // 消费特征
          'purchasing_power': 'choice36', // 购买能力
          'interests': 'choice37',   // 兴趣
          'risk_assessment': 'choice38', // 风险评估
          // 'anamnesis': 'choice39',   // 既往病史
          
          // 护理需求类
          'special_nurse_type': 'choice6', // 特殊项目
          'convention_skill': 'choice7', // 常规技能
          'special_skill': 'choice8',   // 特殊技能
          // 'require_sex': 'choice9',     // 人员需求性别
          'require_age': 'choice10',    // 年龄段
          'require_bodily': 'choice11', // 体型
          // 'require_academic_background': 'choice12', // 学历
          'require_consumption': 'choice13', // 消费需求
        },
        /* eslint-enable no-dupe-keys */
        // 字典数据缓存
        dictCache: {},
        showAreaPicker: false,
        areaList:areaList,
        areaValue:[],

        showHomePicker: false,
        homeList:areaList,
        homeValue:[],

      };
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
      const that = this;
      that.info = that.$route.query.res;
      that.formData = that.info;
      console.log('that.info',that.info);

      // 初始化字典数据
      this.initDictData();
      this.loadDataNo();
      // this.getDictItems();
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    // 方法集合
    methods: {
      onAreaConfirm(selectedValues) {
        // selectedValues 是选中的地区代码数组
        console.log('selectedValues',selectedValues);
        
        const provinceName = selectedValues[0]?.name;
        const cityName = selectedValues[1]?.name;
        console.log('provinceName:', provinceName, 'cityName:', cityName);
        
        if (provinceName && cityName) {
          this.formData.censusRegisterGround = `${provinceName}${cityName}`;
        }
        
        this.showAreaPicker = false;
      },
      onHomeConfirm(selectedValues) {
        // selectedValues 是选中的地区代码数组
        console.log('selectedValues',selectedValues);
        
        const provinceName = selectedValues[0]?.name;
        const cityName = selectedValues[1]?.name;
        const areaName = selectedValues[2]?.name;
        console.log('provinceName:', provinceName, 'cityName:', cityName, 'areaName:', areaName);
        
        if (provinceName && cityName && areaName) {
          this.formData.homeAddress = `${provinceName}${cityName}${areaName}`;
        }
        
        this.showHomePicker = false;
      },
      onBirthConfirm(date) {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        this.formData.birthDate = `${year}-${month}-${day}`
        this.showBirthPicker = false
      },
      openKinshipPicker(index) {
        this.currentMemberIndex = index;
        this.showKinshipPicker = true;
      },
      // 关系选择器确认方法
      onKinshipConfirm(value) {
        console.log('选中的关系:', value);
        
        if (this.consumerFamilyMemberTable.dataSource && this.consumerFamilyMemberTable.dataSource[this.currentMemberIndex]) {
          // 使用 $set 确保响应式更新
          this.$set(
            this.consumerFamilyMemberTable.dataSource[this.currentMemberIndex], 
            'kinship', 
            value.text
          );
        }
        
        this.showKinshipPicker = false;
      },
      
      // 家庭成员生日选择器确认方法
      onMemberBirthConfirm(date) {
        console.log('家庭成员生日选择器确认:', date);
        
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        
        // 获取当前选中的家庭成员索引
        const memberIndex = this.currentMemberIndex;
        
        // 更新显示在界面上的数据源
        if (this.consumerFamilyMemberTable.dataSource && this.consumerFamilyMemberTable.dataSource[memberIndex]) {
          // 更新家庭成员的生日字段
          this.consumerFamilyMemberTable.dataSource[memberIndex].brthday = formattedDate;
          console.log('更新家庭成员生日:', this.consumerFamilyMemberTable.dataSource[memberIndex]);
        }
        
        this.showMemberBirthPicker = false;
      },
      
      // 添加家庭成员方法
      addFamilyMember(event) {
        // 阻止按钮的默认提交行为
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        
        console.log('添加家庭成员');
        
        // 创建新的家庭成员对象
        const newMember = {
          id: Date.now(), // 使用时间戳作为唯一ID
          name: '',
          mobile: '',
          kinship: '',
          brthday: ''
        };
        
        // 添加到家庭成员列表
        this.consumerFamilyMemberTable.dataSource.push(newMember);
        console.log('添加后的家庭成员列表:', this.consumerFamilyMemberTable.dataSource);
      },
      
      // 获取客户访护记录
      loadTraceRecords() {
        // 这里可以调用API获取客户访护记录
        // 暂时使用模拟数据
        this.consumerTraceTable.dataSource = [
          {
            id: 1,
            traceTime: '2023-01-15 10:30',
            traceUser: '张护士',
            traceContent: '定期健康检查，血压正常，精神状态良好',
            traceTags: '健康检查,血压监测',
            nextTraceTime: '2023-02-15'
          },
          {
            id: 2,
            traceTime: '2023-01-10 14:00',
            traceUser: '李医生',
            traceContent: '药物调整，观察用药反应',
            traceTags: '药物调整,观察',
            nextTraceTime: '2023-01-20'
          }
        ];
        console.log('加载客户访护记录:', this.consumerTraceTable.dataSource);
      },
      
      // 删除家庭成员方法
      removeFamilyMember(index) {
        console.log('删除家庭成员，索引:', index);
        
        // 确认删除
        this.consumerFamilyMemberTable.dataSource.splice(index, 1);
        // console.log('删除后的家庭成员列表:', this.consumerFamilyMemberTable.dataSource);
        // if (confirm('确定要删除这个家庭成员吗？')) {
        //   // 从数组中删除指定索引的元素
          
        // }
      },
      loadDataNo(){
        loadData().then(res => { 
          this.choice14 = res.data.result.map(item => ({
            text: item.name,
            value: item.id
          }));
        })
      },
      closedChange(e) {
        // console.log('e',e);
        
        // 确保e是有效的storeId值
        const storeId = typeof e === 'object' ? e.value || e.id || e.storeId : e;
        
        if (!storeId) {
          console.warn('无效的storeId:', e);
          return;
        }
        
        nurseEmployeeStore(storeId).then(res => {
          if (res.data && res.data.result) {
            this.choice15 = res.data.result.map(item => ({
              text: item.name,
              value: item.id
            }));
          }
        }).catch(error => {
          console.error('获取护理员列表失败:', error);
        });
        storeUsers(storeId).then(res => {
          if (res.data && res.data.result) {
            this.choice16 = res.data.result.map(item => ({
              text: item.realname,
              value: item.id
            }));
          }
        }).catch(error => {
          console.error('获取督导员列表失败:', error);
        });
      },
      onSubmit(){
        // 处理数组字段，转换为字符串格式
        const processedData = { ...this.formData };
        
        // 定义需要转换为字符串的数组字段
        const arrayFields = [
          'traitsCharacter',    // 性格特征
          'dieteticHabit',      // 饮食习惯
          'consumptionFeature', // 消费特征
          'interests',          // 兴趣
          'anamnesis',          // 既往病史
        ];
        
        // 将数组字段转换为逗号分隔的字符串
        arrayFields.forEach(field => {
          if (Array.isArray(processedData[field])) {
            processedData[field] = processedData[field].join(',');
            console.log(`转换字段 ${field}:`, processedData[field]);
          }
        });
        
        console.log('处理后的formData:', processedData);
        consumerEdit({
          processedData,
          consumerFamilyMemberList : this.consumerFamilyMemberTable.dataSource || []
        }).then((res) => {
          if (res.data.success) {
            this.$toast('编辑成功');
            this.$router.back();
          } else {
            this.$toast('编辑失败');
          }
        }).catch(error => {
          console.error('编辑失败:', error);
          this.$toast('编辑失败');
        });
      },
      // initToken(id) {
      //   const that = this;
      //   listNew({ id : id }).then((res) => {
      //     if (res.data.success) {
      //       that.data = res.data.result.records;
      //       console.log('that.data',that.data);
      //       that.data.forEach(element => {
      //         if(element.id == that.info.id){
      //           console.log(1);
      //         }
      //       });
      //     }
      //   });
      // },
      // 初始化字典数据
      async initDictData() {
        try {
          const dictCodes = Object.keys(this.dictConfig);
          const promises = dictCodes.map(dictCode => this.getDictData(dictCode));
          await Promise.all(promises);
          console.log('字典数据初始化完成');
        } catch (error) {
          console.error('字典数据初始化失败:', error);
        }
      },
      
      // 获取字典数据
      async getDictData(dictCode) {
        try {
          // 检查缓存
          if (this.dictCache[dictCode]) {
            this.assignDictDataToChoices(dictCode, this.dictCache[dictCode]);
            return;
          }
          
          const response = await getDictItems(dictCode);
          if (response && response.data) {
            // 缓存数据
            this.dictCache[dictCode] = response.data;
            // 分配数据到对应的choice数组
            this.assignDictDataToChoices(dictCode, response.data);
          }
        } catch (error) {
          console.error(`获取字典数据 ${dictCode} 失败:`, error);
        }
      },
      
      // 分配字典数据到对应的choice数组
      assignDictDataToChoices(dictCode, dictData) {
        // console.log('分配字典数据:', dictCode, dictData);
        if(dictCode === 'anamnesis'){
          this.choice39 = dictData.result.map(item => ({
            text: item.text,
            value: item.value
          }));
          // console.log('已分配既往病史数据到choice39');
        }
        // 处理特殊字典代码
        if (dictCode === 'nurse_assistant_academic_background') {
          // 同时更新两个choice数组
          this.choiceOn = dictData.result.map(item => ({
            text: item.text,
            value: item.value
          }));
          this.choice12 = dictData.result.map(item => ({
            text: item.text,
            value: item.value
          }));
          // console.log('已分配学历数据到choiceOn和choice12');
          return;
        } else if(dictCode === 'sex'){
          this.choice1 = dictData.result.map(item => ({
            text: item.text,
            value: item.value
          }));
          this.choice9 = dictData.result.map(item => ({
            text: item.text,
            value: item.value
          }));
          // console.log('已分配性别数据到choice1和choice9');
          return;
        }
        
        // 处理其他字典代码
        const targetChoice = this.dictConfig[dictCode];
        if (targetChoice && Array.isArray(dictData.result)) {
          this[targetChoice] = dictData.result.map(item => ({
            text: item.text,
            value: item.value
          }));
          // console.log(`已分配 ${dictCode} 到 ${targetChoice}:`, this[targetChoice]);
        } else {
          console.warn(`未找到 ${dictCode} 的配置或数据无效`);
        }
      },
      
      
    },
};
</script>
<style lang="less" scoped>
html {
  height: 100vh;
  // background: #f0efef;
}

[v-cloak] {
  display: none !important;
}

.fangTan_container {
  // background: #f0efef;
  width: 100%;
  height: 100vh;
}

/deep/ .van-nav-bar {
  background: #0dacf4;

  .van-nav-bar__title {
    color: #fff;
  }
}
// /deep/ .van-nav-bar {
//   background: var(--color);

//   .van-nav-bar__title {
//     color: #fff;
//   }
// }

/deep/ .van-nav-bar__left {
  .van-icon,
  .van-nav-bar__text {
    color: #fff;
  }
}

.con {
  // background: #f0efef;
}

.myInfo {
  margin: 14px;

  .info {
    height: 200px;

    .title {
      height: 20px;
      line-height: 20px;

      span {
        margin-left: 6px;
        font-size: 16px;
        color: #333333;
      }

      .box {
        width: 347px;
        // height: 153px;
        background: #f0efef;
        border-radius: 6px;
        margin-top: 10px;

        .box_item {
          padding: 14px 0 14px 26px;
          width: 272px;
          // height: 118px;
          font-size: 14px;
          font-family: Alibaba PuHuiTi;
          font-weight: 300;
          color: #666666;
          line-height: 26px;

          .box_item_title{
            font-size: 16px;
            color: #0f21e6;
          }

          .contains {
            word-break: keep-all;
            /* 不换行 */
            width: 272px;
            overflow-x: auto;
            white-space: nowrap;
            /* 不换行 */
          }
        }
      }
    }
  }

  .talk {
    margin-top: 14px;

    .titlt_talk {
      margin-left: 6px;
      font-size: 16px;
      color: #333333;
    }

    .talk_item {
      width: 347px;
      height: 104px;
      margin-top: 14px;
      background: #ffffff;
      border-radius: 14px 6px 6px 6px;

      .tip {
        width: 81px;
        height: 28px;
        text-align: center;
        line-height: 28px;
        color: #fff;
        background: linear-gradient(0deg, #0ecde1 0%, #2bd79f 100%);
        border-radius: 14px 0px 14px 0px;
        font-size: 12px;
      }

      .serve_name {
        text-align: center;
        line-height: 52px;
        font-size: 14px;
        position: relative;

        .pay {
          text-align: left;
          margin-left: 12px;
          line-height: 4px;
          color: #666666;
        }

        .payBtn {
          position: absolute;
          right: 10px;
          top: -6px;

          button {
            width: 58px;
            height: 26px;
            margin-right: 10px;
          }
        }

        .icon {
          margin-left: 20px;
        }
      }
    }

    .none_talk {
      margin-top: 50px;

      .create_talk {
        width: 100%;
        text-align: center;

        button {
          width: 230px;
          background: linear-gradient(0deg, #6eaefc, #6875f1);
          font-size: 15px;
          border-radius: 21px;
          border: none;
        }
      }
    }
  }

  /deep/ .van-popup {
    width: 90%;
    height: 70%;
  }

  .popCell {
    padding: 20px 0;

    .p {
      font-size: 20px;
    }
  }
}

.over {
  /deep/ .van-overlay {
    background: rgba(0, 0, 0, 0.1);
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 304px;
    height: 386px;
    background-color: #fff;
  }

  .fontTip {
    line-height: 22px;
  }
  
  // 标签页相关样式
  .family-member-table {
    padding: 10px;
    
    .member-item {
      margin-bottom: 15px;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      
      .member-actions {
        padding: 10px;
        display: flex;
        gap: 10px;
        justify-content: flex-end;
        
        .van-button {
          min-width: 80px;
        }
      }
    }
  }
  
  .empty-state {
    padding: 40px 0;
  }
  
  .order-list, .coupon-list, .integral-list {
    padding: 10px;
    
    .order-item, .coupon-item, .integral-item {
      margin-bottom: 10px;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
      
      .van-cell {
        &:first-child {
          border-bottom: 1px solid #f5f5f5;
        }
      }
    }
  }
  
  // 调整标签页样式
  .van-tabs {
    margin-top: 10px;
    
    .van-tab__pane {
      padding: 0;
    }
  }
}
</style>